// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/notifications.

import { useBackend } from '../useBackend'

/** POST /api/notifications/dismissNotification */
export function useDismissNotification<T = any>() {
  return useBackend<T>('notifications/dismissNotification')
}

/** POST /api/notifications/getMyWorkCounts */
export function useGetMyWorkCounts<T = any>() {
  return useBackend<T>('notifications/getMyWorkCounts')
}

/** POST /api/notifications/getNotifications */
export function useGetNotifications<T = any>() {
  return useBackend<T>('notifications/getNotifications')
}

/** POST /api/notifications/markNotificationsSeen */
export function useMarkNotificationsSeen<T = any>() {
  return useBackend<T>('notifications/markNotificationsSeen')
}
